module.exports = __webpack_public_path__ + "img/3.1a61f7f5.png";